import { ReactComponent as BreathingExercisesIcon } from "@icons/breathing-exercises-sm.svg";
import { ClickableRoundedCard } from "../../../Support/Components/ContactCard/ClickableRoundedCard";
import { Icon } from "UIPalette/Icon/Icon";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

export function BreathingExercisesCard() {
  const navigate = useNavigate();
  return (
    <ClickableRoundedCard
      title={t("home.breathingExercises.title")}
      icon={<Icon icon={<BreathingExercisesIcon />} bgColour="bg-sky" hasDropShadow={false} />}
      description={t("home.breathingExercises.description")}
      handleClick={() => navigate("/breathing-exercises")}
      showChevron
    />
  );
}
